import React from "react";

export default function InTransitIcon(props) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.5 8.5H19.75L22.5 12.1667V16.5H16.5V8.5Z" stroke="#2B56A3" />
      <path d="M17 11.5L22.5 12V16.5L17 16V11.5Z" fill="#2B56A3" />
      <path d="M1.75 16.25V6.12465L3.40428 4.75H16.25V16.25H1.75Z" stroke="#CA367E" strokeWidth="1.5" />
      <circle cx={6} cy={17} r="2.25" fill="white" stroke="#2B56A3" strokeWidth="1.5" />
      <circle cx={18} cy={17} r="2.25" fill="white" stroke="#2B56A3" strokeWidth="1.5" />
    </svg>
  );
}
